// Al page indices

export const INFO_PAGE = 0;

export const ATTRIBUTES_PAGE = 1;

export const IMAGES_PAGE = 2;

export const ASSET_BUNDLE_PAGE = 3;

export const LOADING_PAGE = 4;

export const QR_PAGE = 5;

// Maximun page index

export const MAX_PAGE = 5;



// WEBPACK FOOTER //
// ./src/redux/NewProductForm/pages.js